import ActionButton from "@/components/Button/ActionButton";
import {
  DataTable,
  simpleTextColumn,
  useTableDisplayState,
} from "@/components/DataTable";
import { FillScreen, HStack } from "@/components/Layout";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { Link, createFileRoute } from "@tanstack/react-router";
import {
  type ColumnDef,
  getCoreRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { useState } from "react";
import ActionsColumn from "./-columns/ActionsColumn";
import CellDeviceColumn from "./-columns/CellDeviceColumn";
import CheckBoxColumn from "./-columns/CheckBoxColumn";
import { DateColumn } from "./-columns/DateColumn";
import { useDevices } from "./-query/useDevices";
import type { PeopleDevicesTableRow } from "./-type";

export const Route = createFileRoute("/_staff/person/$id/_profile/devices/")({
  component: PeopleDevices,
});

function PeopleDevices() {
  const { data: devices, isPending } = useDevices(Route.useParams().id);

  const [checkedRows, setCheckedRows] = useState<
    {
      deviceId: string;
    }[]
  >([]);

  const columns: ColumnDef<PeopleDevicesTableRow>[] = [
    CheckBoxColumn("selectable", {}, checkedRows, setCheckedRows),
    CellDeviceColumn("device", {
      i18nKey: "device",
      sortable: false,
      minWidth: "240px",
    }),
    simpleTextColumn("device.model", {
      i18nKey: "model",
      sortable: false,
      minWidth: "240px",
    }),
    simpleTextColumn("computer.ram", {
      i18nKey: "ram",
      sortable: false,
    }),
    simpleTextColumn("computer.storage", {
      i18nKey: "storage",
      sortable: false,
    }),
    simpleTextColumn("monitor.displaySize", {
      i18nKey: "displaySize",
      sortable: false,
    }),
    simpleTextColumn("fixedAsset.assetTag", {
      i18nKey: "assetTag",
      sortable: false,
    }),
    DateColumn("user.assignedDate", {
      i18nKey: "assignedDate",
      sortable: false,
    }),
    DateColumn("procurementDate", {
      i18nKey: "procurementDate",
      sortable: false,
    }),
    // TODO: mdm app バックエンド未対応
    simpleTextColumn("mdmApp", {
      i18nKey: "mdmApp",
      sortable: false,
    }),
    // TODO: sim バックエンド未対応
    simpleTextColumn("sim", {
      i18nKey: "sim",
      sortable: false,
    }),
    ActionsColumn("actions"),
  ];

  const table = useReactTable({
    data: devices,
    // pageCount,
    columns: columns,
    initialState: {
      columnPinning: { left: ["selectable"], right: ["actions"] },
    },
    state: {},
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    // onPaginationChange: setPagination,
    // onColumnVisibilityChange: setColumnVisibility,
    // onSortingChange: setSorting,
    manualPagination: true,
    manualSorting: true,
  });

  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.person.devices",
  });

  const displayState = useTableDisplayState(isPending, devices);

  return (
    <FillScreen className="flex flex-col gap-4 px-12 py-6">
      <HStack className="justify-end gap-2">
        {/* TODO: 未実装 */}
        <Link to="/apps/marketplace" disabled>
          <ActionButton
            className="gap-2"
            size="sm"
            variant="outline"
            icon="UserRoundMinusIcon"
            iconColor="active"
            disabled
          >
            {t("unassignButton")}
          </ActionButton>
        </Link>

        {/* TODO: 未実装 */}
        <Link to="/apps/marketplace" disabled>
          <ActionButton
            className="gap-2"
            size="sm"
            variant="outline"
            icon="UserRoundPlusIcon"
            iconColor="active"
            disabled
          >
            {t("assignButton")}
          </ActionButton>
        </Link>
      </HStack>
      <DataTable table={table} displayState={displayState} />
      {/* <DataTablePagination table={table} /> */}
    </FillScreen>
  );
}
